'use client';

import Intercom from '@intercom/messenger-js-sdk';
import type { InitType } from '@intercom/messenger-js-sdk/types';

export type IntercomChatbotProps = {
    config: InitType;
};

export const IntercomChatbot = ({ config }: IntercomChatbotProps) => {
    if (!config.app_id || !config.api_base) {
        return null;
    }

    Intercom(config);

    return null;
};
